import { render, staticRenderFns } from "./ClientRegisterCharge.vue?vue&type=template&id=538043fb&scoped=true"
import script from "./ClientRegisterCharge.vue?vue&type=script&lang=js"
export * from "./ClientRegisterCharge.vue?vue&type=script&lang=js"
import style0 from "./ClientRegisterCharge.vue?vue&type=style&index=0&id=538043fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538043fb",
  null
  
)

export default component.exports